import styled from "styled-components";
import { MediaQuery, spacingExtender } from "ui-components";

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 2;
  position: relative;
  height: calc(100vh - 60px);
  overflow: auto;
  ${() => spacingExtender({ paddingH: "3", paddingV: "4" })};

  /* Remove content's right padding on large screens */
  ${MediaQuery.largeUp`padding-right: 0;`};
`;

const ContentLayout = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  position: relative;
  overflow: hidden;
  border-radius: 5px;
  background-color: white;
  box-shadow: ${({ theme }) => theme.shadow};
  ${() => spacingExtender({ marginV: "4" })}
`;

export { ContentWrapper, ContentLayout };



// WEBPACK FOOTER //
// ./src/common/styled/content.js